import S from '@/settings'
import { ENV } from '@/lib/constants/env'
const { PROD, DEV, LOCAL } = ENV
const { BASE_URL } = S
export default function getBaseURL() {
  if (process.env.IS_TESTING) return BASE_URL.test
  if (process.env.ENV === LOCAL) return BASE_URL.local
  if (process.env.ENV === PROD) return BASE_URL.production
  if (process.env.ENV === DEV) return BASE_URL.development
  return BASE_URL.local
}
